/**
 * Typed access to Vite env vars.
 * All runtime-required keys are validated at module load so a misconfigured
 * deploy fails fast instead of crashing a user-facing request.
 */

interface NeoEnv {
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  SENTRY_DSN: string | undefined;
  APP_ENV: "development" | "preview" | "production";
}

function required(key: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required env var ${key}. Set it in .env.local (dev) or Vercel project settings (preview/production).`,
    );
  }
  return value;
}

export const env: NeoEnv = {
  SUPABASE_URL: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  SUPABASE_ANON_KEY: required(
    "VITE_SUPABASE_ANON_KEY",
    import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  APP_ENV: (import.meta.env.VITE_APP_ENV as NeoEnv["APP_ENV"]) ?? "development",
};
